
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/whatsapp-for-education-ebook",
      function () {
        return require("private-next-pages/resources/whatsapp-for-education-ebook.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/whatsapp-for-education-ebook"])
      });
    }
  